export default {
  signup: 'sign up',
  login: 'login',
};



// WEBPACK FOOTER //
// ./src/models/ActionBtns.js